declare global {
  interface Window {
    embeddedservice_bootstrap?: {
      settings: { language?: string };
      init: (
        orgId: string,
        deploymentName: string,
        siteUrl: string,
        options: { scrt2URL: string }
      ) => void;
    };
  }
}

interface ServiceCredentials {
  orgId: string;
  deploymentName: string;
  siteUrl: string;
  scrt2Url: string;
  bootstrapScriptUrl: string;
}

export const loadEmbeddedChatService = () => {
  const creds = determineChatCredentials();

  if (!window.embeddedservice_bootstrap) {
    console.log('ESW exists:', window.embeddedservice_bootstrap);
    const script = document.createElement("script");
    script.src = creds.bootstrapScriptUrl;

    script.onload = () => {
      initializeService(creds);
    };

    script.onerror = () => {
      console.error("Failed to load Embedded Service bootstrap script", creds.bootstrapScriptUrl);
    };

    document.body.appendChild(script);
  } else {
    initializeService(creds);
  }
};

const initializeService = (creds: ServiceCredentials) => {
  const esw = window.embeddedservice_bootstrap;
  if (!esw) return;

  esw.settings.language = "en_US";
console.log('Init creds:', creds);

  esw.init(creds.orgId, creds.deploymentName, creds.siteUrl, {
    scrt2URL: creds.scrt2Url,
  });
};

const determineChatCredentials = (): ServiceCredentials => {
  const env = process.env;

  const workingHoursStart = env.REACT_APP_WORKING_HOURS_START?.split(":").map(
     (e) => +e
  );
  const workingHoursEnd = env.REACT_APP_WORKING_HOURS_END?.split(":").map(
     (e) => +e
  );

  if (!workingHoursStart || !workingHoursEnd) 
    throw new Error("Working hours not provided");

  // TODO add handling of UK timezone. Working hours should be calculated according to UK timezone.

  const startDate = new Date();
  startDate.setHours(workingHoursStart[0], workingHoursStart[1], 0);
  const endDate = new Date();
  endDate.setHours(workingHoursEnd[0], workingHoursEnd[1], 0);
  const currentDate = new Date();
  const isWorkingHour = startDate <= currentDate && currentDate < endDate;

  const deploymentName = isWorkingHour
    ? env.REACT_APP_ESW_DEPLOYMENT_NAME_ONLINE
    : env.REACT_APP_ESW_DEPLOYMENT_NAME_OFFLINE;

  const siteUrl = isWorkingHour
    ? env.REACT_APP_ESW_SITE_URL_ONLINE
    : env.REACT_APP_ESW_SITE_URL_OFFLINE;

  const scrt2Url = env.REACT_APP_ESW_SCRT2_URL!;

  const bootstrapScriptUrl = isWorkingHour
    ? env.REACT_APP_ESW_BOOTSTRAP_SCRIPT_URL_ONLINE
    : env.REACT_APP_ESW_BOOTSTRAP_SCRIPT_URL_OFFLINE;

  if (!deploymentName || !siteUrl || !scrt2Url || !bootstrapScriptUrl)
    throw new Error("ESW credentials not provided");

  return {
    orgId: env.REACT_APP_ESW_ORG_ID!,
    deploymentName,
    siteUrl,
    scrt2Url,
    bootstrapScriptUrl,
  };
};
